import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase'
import { VALID_ROLES } from '@/config/roles'

// Read-only: verifies the signed-in user is fully bootstrapped — Firestore
// user doc exists, JWT role claim is present/valid, and doc + claim agree.
export default {
  id: 'authBootstrap',
  label: 'Auth bootstrap',
  description: 'User doc exists, JWT role claim valid, doc and claim agree.',
  destructive: false,

  async run(ctx, step) {
    let userDoc
    await step('read own user document', async () => {
      const snap = await getDoc(doc(db, 'users', ctx.user.uid))
      if (!snap.exists()) throw new Error(`users/${ctx.user.uid} does not exist`)
      userDoc = snap.data()
      return `role=${userDoc.role || '(none)'}`
    })

    await step('JWT role claim is valid', async () => {
      if (!ctx.roleClaim) throw new Error('Token has no role claim (syncUserClaims not run?)')
      if (!VALID_ROLES.includes(ctx.roleClaim)) {
        throw new Error(`Claim role "${ctx.roleClaim}" is not a valid role`)
      }
      return ctx.roleClaim
    })

    await step('user doc role matches claim', async () => {
      if (userDoc.role !== ctx.roleClaim) {
        throw new Error(`doc role "${userDoc.role}" ≠ claim role "${ctx.roleClaim}"`)
      }
      return userDoc.role
    })
  }
}
